import { render, staticRenderFns } from "./org-select-popover.vue?vue&type=template&id=604a6103&scoped=true&"
import script from "./org-select-popover.vue?vue&type=script&lang=js&"
export * from "./org-select-popover.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "604a6103",
  null
  
)

export default component.exports